import { OnlineTimeAppLast30Days } from 'Consts/types';

import * as api from 'Api/endpoints';

import type { RootState, Action } from 'State/store';
import { createStandardSlice } from 'State/utils';

const slice = createStandardSlice<OnlineTimeAppLast30Days>(
  'personsMonthlyAppsOnlineTime'
);

const fetchData = (personId: string): Action => {
  return async (dispatch, getState) => {
    const { activeLocation } = getState().locations;
    const customerId = activeLocation?.customerId;
    const { data: token } = getState().locations.activeLocation
      ?.accessedAsCoAdminLocation
      ? getState().auth.coAdminData
      : getState().auth.data;
    const cloud = getState().auth.cloud;
    const personMonthlyAppsOnlineTime =
      getState().appsOnlineTime.employee.monthly;

    if (
      personMonthlyAppsOnlineTime.isLoading ||
      !personId ||
      !customerId ||
      !token ||
      !activeLocation?.id
    ) {
      return;
    }

    dispatch(actions.isLoading(true));

    const { data, error } = await api.getPersonMonthlyOnlineAppTime({
      customerId,
      locationId: activeLocation.id,
      personId,
      token,
      cloud,
    });

    if (error || !data) {
      dispatch(
        actions.error(error?.message || 'Error fetching Apps online time')
      );
      return;
    }

    dispatch(actions.set(data.last30Days));
  };
};

export const selectors = (state: RootState) =>
  state.appsOnlineTime.persons.monthly;

export const actions = {
  ...slice.actions,
  fetchData,
};

export default slice.reducer;
